import React from 'react';

// Importing all sections used in the homepage
import { Home, About, Counter, Testimonials, Blogs, Services, Team, Banner, Clients, Industries, WhyUs, Mission, NewsletterSection, Process, CaseSection, Pricing, FAQs, HomeFeatures } from '../../sections';
import { faqsContent } from '../../constants';



const HomePage = () => {

  return (
    <div className='homepage'>
      <Home /> {/* Home Section */}
      <HomeFeatures /> {/* Home Features Section */}
      <About /> {/* About Section */}
      <WhyUs /> {/* Why Choose Us Section */}
      <Services /> {/* Services Slider */}
      <Counter /> {/* Counter Section */}
      <Process /> {/* Process Slider */}
      <Banner /> {/* Banner Section */}
      <CaseSection /> {/* Case Studies Section */}
      <Mission /> {/* Mission Section */}
      <Pricing /> {/* Pricing Section */}
      <Industries /> {/* Industries Section */}
      <FAQs faqsContent={faqsContent} /> {/* FAQs Section */}
      <Testimonials /> {/* Testimonials Slider */}
      <Team /> {/* Team section */}
      <NewsletterSection /> {/* Newsletter Section */}
      <Blogs /> {/* Latest blog posts */}
      <Clients /> {/* Clients Slider */}
    </div>
  )

}

export default HomePage;